import type { AvailableIcons } from "~/components/ui/Icon"
import Slider from "~/components/ui/Slider"
import SliderJS from "~/components/ui/SliderJS"
import Title from "~/components/ui/Title"
import { ImageWidget } from "~/types/widgets"
import Icon from "~/components/ui/Icon"
import { TitleIcon } from "~/loaders/TitleIcon"

/**
 * @title Cor
 * @format color
 */
type Color = string

/**
 * @title Remover Cor
 */
type NoColor = null

/**
 * @titleBy id
 */
interface IconProps {
    /**
     * @title Ícone
     */
    id: AvailableIcons

    /**
     * @title Tamanho
     */
    size: number

    /**
     * @title Cor
     */
    color: Color | NoColor

    /**
     * @title Traço do Ícone
     */
    strokeWidth: number
}

export interface Item {
    /**
     * @title Imagem
     */
    image: ImageWidget

    /**
     * @title Nome
     */
    label?: string

    /**
     * @title Link
     */
    url: string
}

export interface Props {
    /**
     * @title Título
     * @format html
     */
    title?: string

    /**
     * @title Ícone do título
     */
    titleIcon?: TitleIcon

    /**
     * @title Itens
     */
    items: Item[]
}

export default function Highlights({ title, titleIcon, items }: Props) {
    if (!items?.length) return null

    return (
        <div className='w-full my-12 px-3.5 flex flex-col justify-center gap-8 lg:gap-14'>
            {title && <Title title={title} icon={titleIcon} />}

            <div
                id='highlights-slider'
                className='w-full max-w-[1024px] mx-auto relative min-[1360px]:max-w-[1220px]'
            >
                <Slider className='carousel w-full'>
                    {items.map((item, index) => (
                        <Slider.Item
                            className='carousel-item w-1/2 justify-center group md:w-1/4 lg:w-1/5'
                            index={index}
                        >
                            <a className='grid justify-items-center' href={item.url}>
                                <div className='w-[150px] h-[150px] mb-4 border border-[#cbcbcb] rounded-full flex justify-center items-center transition-colors duration-300 group-hover:border-red-wine'>
                                    <img
                                        className='transition-transform duration-300 group-hover:scale-105'
                                        src={item.image}
                                        alt={item.label}
                                        loading='lazy'
                                    />
                                </div>

                                <p className='font-medium transition-colors duration-300 group-hover:text-red-wine'>
                                    {item.label}
                                </p>
                            </a>
                        </Slider.Item>
                    ))}
                </Slider>

                <Slider.PrevButton className='w-14 h-14 rounded-full bg-[#e7e6e1] flex justify-center items-center absolute top-[75px] -translate-y-1/2 left-0 -translate-x-2 xl:w-[75px] xl:h-[75px] xl:-translate-x-14'>
                    <Icon id='ChevronLeft' className='text-[#e6b2ad]' size={48} strokeWidth={1} />
                </Slider.PrevButton>

                <Slider.NextButton className='w-14 h-14 rounded-full bg-[#e7e6e1] flex justify-center items-center absolute top-[75px] -translate-y-1/2 right-0 translate-x-2 xl:w-[75px] xl:h-[75px] xl:translate-x-14'>
                    <Icon id='ChevronRight' className='text-[#e6b2ad]' size={48} strokeWidth={1} />
                </Slider.NextButton>

                <SliderJS rootId='highlights-slider' infinite />
            </div>
        </div>
    )
}
